module.exports = __webpack_public_path__ + "static/img/7areaB_05.8cf3fc1.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/7areaB_05.png
// module id = 1217
// module chunks = 1